export function InstructModelBadge() {
  return (
    <span className="flex items-center justify-center rounded-md bg-tertiary px-1.5 py-[0.1rem] font-mono text-[11px] font-semibold">
      Instruct
    </span>
  );
}
